import axios from "axios";
import settings from "../settings";

const et = {
    weekDays: ["Esmaspäev", "Teisipäev", "Kolmapäev", "Neljapäev", "Reede", "Laupäev", "Pühapäev"],
    weekDaysShort: ["E", "T", "K", "N", "R", "L", "P"],
    months: [
        "Jaanuar",
        "Veebruar",
        "Märts",
        "Aprill",
        "Mai",
        "Juuni",
        "Juuli",
        "August",
        "September",
        "Oktoober",
        "November",
        "Detsember",
    ],
    years: "Aastad",
    year: "Aasta",
    month: "Kuu",
    week: "Nädal",
    day: "Päev",
    today: "Täna",
    noEvent: "Sündmusi pole",
    allDay: "Kogu päev",
    deleteEvent: "Kustuta sündmus",
    createEvent: "Loo sündmus",
    dateFormat: "YYYY MMMM D dddd",
};

const sizeOptions = {
    incoming: [
        {id: "truck_33_pallets", value: 60, text: "Auto, 33+ alust"},
        {id: "truck_20_pallets", value: 30, text: "Auto, 20-32, alust"},
        {id: "1_19_pallets", value: 15, text: "Auto, 1-19 alust"},
        {id: "20_foot_container_without_pallets", value: 240, text: "Container, 20 feet, Without pallets"},
        {id: "40_foot_container_without_pallets", value: 300, text: "Container, 40 feet, Without pallets"},
        {id: "20_foot_container_with_pallets", value: 60, text: "Container, 20 feet, With pallets"},
        {id: "40_foot_container_with_pallets", value: 120, text: "Container, 40 feet, With pallets"}
    ],
    outgoing: [
        {id: "truck_33_pallets", value: 45, text: "Auto, 33+ alust"},
        {id: "truck_20_pallets", value: 25, text: "Auto, 20-32, alust"},
        {id: "1_19_pallets", value: 15, text: "Auto, 1-19 alust"},
        {id: "20_foot_container_without_pallets", value: 240, text: "Container, 20 feet, Without pallets"},
        {id: "40_foot_container_without_pallets", value: 480, text: "Container, 40 feet, Without pallets"},
        {id: "20_foot_container_with_pallets", value: 60, text: "Container, 20 feet, With pallets"},
        {id: "40_foot_container_with_pallets", value: 120, text: "Container, 40 feet, With pallets"}
    ]
};

let initialState = {
    dataLoading: false,
    submitLoading: false,
    requestError: false,
    createdEvent: null,
    shipments: {
        incoming: [],
        outgoing: [],
    },
    errorMessage: "",
    sizes: sizeOptions,
    vuecalLocale: et,
    companyName: null,
    direction: null,
    shipmentStatus: null,
    savedData: null,
};

export default {
    namespaced: true,
    state: {...initialState},
    actions: {
        async fetchData({commit}, token) {
            commit("setDataLoading", true);
            commit("setErrorMessage", "");

            try {
                const response = await axios.get(settings.public_url + "/shipment", {
                    params: {token}
                });

                if (response.status === 200 && response.data.success) {
                    commit("setShipments", response.data.shipments);
                    commit("setCompanyName", response.data.company_name);
                    commit("setDirection", response.data.direction);
                    commit("setShipmentStatus", response.data.status);
                    commit("setSavedData", response.data.saved_data);

                    return true;
                } else {
                    commit("setErrorMessage", response.data.error_msg || "");
                    return false;
                }
            } catch (e) {
                commit("setErrorMessage", "Network or server error");
                return false;
            } finally {
                commit("setDataLoading", false);
            }
        },
        async submitEvent({commit, dispatch}, payload) {
            commit("setSubmitLoading", true);
            commit("setRequestError", false);
            commit("setErrorMessage", "");

            try {
                const response = await axios.post(settings.public_url + "/shipment", payload);

                if (response.status === 200 && response.data.success === 1) {
                    return true;
                } else {
                    commit("setRequestError", true);
                    commit("setErrorMessage", response.data.error_msg);
                    return false;
                }
            } catch (e) {
                console.log(e);
                commit("setRequestError", true);
                return false;
            } finally {
                commit("setSubmitLoading", false);
            }
        },
    },
    mutations: {
        setRequestError(state, bool) {
            state.requestError = bool;
        },
        setErrorMessage(state, message) {
            state.errorMessage = message;
        },
        setShipments(state, shipments) {
            state.shipments = shipments;
        },
        setCompanyName(state, name) {
            state.companyName = name;
        },
        setDirection(state, direction) {
            state.direction = direction;
        },
        setShipmentStatus(state, status) {
            state.shipmentStatus = status;
        },
        setDataLoading(state, value) {
            state.dataLoading = value;
        },
        setSubmitLoading(state, value) {
            state.submitLoading = value;
        },
        setCreatedEvent(state, event) {
            state.createdEvent = event;
        },
        setSavedData(state, data) {
            state.savedData = data;
        },
    },
};
